import React from "react";
import { Users } from "lucide-react";
import { useSelector } from "react-redux";
import SearchSection from "../components/allMentors/SearchSection";
import MentorCard from "../components/allMentors/MentorCard";
import Sidebar from "../components/allMentors/Sidebar";
import SecondaryLoader from "../components/SecondaryLoader/SecondaryLoader";
import { useMentors } from "../hooks/useMentors";
import { COLORS } from "../constants/colors";

const AllMentors = () => {
  const userType = localStorage.getItem("userType");
  const {
    filteredMentors,
    isLoading,
    handleAppointment,
    activeFilters,
    handleCategoryFilter,
    clearFilters
  } = useMentors();

  return (
    <div className="flex gap-6 min-h-screen p-1">
      {/* Main Content Area */}
      <div className={`${userType === "mentor" ? "w-full" : "flex-1"} space-y-6`}>
        {/* Search Section */}
        <SearchSection 
          activeFilters={activeFilters}
          onFilterChange={handleCategoryFilter}
          onClearFilters={clearFilters}
        />

        {/* Connect with a Mentor Section */}
        <div className="bg-gray-50 border border-gray-300 rounded-xl p-6 shadow-sm">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ backgroundColor: COLORS.purple }}>
              <Users className="w-5 h-5 text-white" />
            </div>
            <div>
              <h2 className="text-lg font-bold text-gray-900">
                {userType === "mentor" ? "Explore Other Mentors" : "Connect with a Mentor"}
              </h2>
              <p className="text-sm text-gray-600">
                {userType === "mentor" ? "Discover and connect with fellow mentors." : "Connect with industry experts."}
              </p>
            </div>
          </div>

          {/* Mentor Cards */}
          {isLoading ? (
            <SecondaryLoader />
          ) : filteredMentors.length > 0 ? (
            <div className={`grid gap-6 ${userType === "mentor" ? "sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4" : "sm:grid-cols-2 lg:grid-cols-3"}`}>
              {filteredMentors.map((mentor) => (
                <MentorCard
                  key={mentor.userId}
                  mentor={mentor}
                  onAppointment={handleAppointment}
                  userType={userType}
                />
              ))}
            </div>
          ) : (
            <div className="text-center py-10">
              <p className="text-gray-500 text-lg font-semibold">No mentors found</p>
            </div>
          )}
        </div>
      </div>

      {/* Right Sidebar - Only show for mentees */}
      {userType !== "mentor" && <Sidebar />}
    </div>
  );
};

export default AllMentors;
